import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
  Rating,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  styled,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Radio as MuiRadio } from "@mui/material";

import { enqueueSnackbar } from "notistack";
import { feedback_api_by_web } from "../../DAL/TalentSourceAPI/TalentSourceApi";
import CustomModalLayout from "../modal/CustomModalLayout";
import {
  feedback_business_icon,
  feedback_comment_icon,
  feedback_person_icon,
  feedback_question_icon,
  feedback_suggestion_icon,
  lock_icon,
} from "../../assets";
const GrayDisabledRadio = styled(MuiRadio)(({ theme }) => ({
  "&.Mui-disabled": {
    color: theme.palette.grey[500], // Gray color for disabled state
  },
}));

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    width: "900px",
    maxWidth: "95vw",
    borderRadius: "12px",
    overflow: "hidden",
  },
});

const FeedBack = ({ openFeedback, setOpenFeedback, user }) => {
  const [IsSubmitting, setIsSubmitting] = useState(false);
  const initial_values = {
    first_name: "",
    last_name: "",
    email: "",
    feedback_type: "",
    feedback: "",
    user_type: "",
    rating: 0,
  };
  const [formData, setFormData] = useState(initial_values);
  const [isUserTypeDisabled, setIsUserTypeDisabled] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRatingChange = (event, newValue) => {
    setFormData((prev) => ({ ...prev, rating: newValue }));
  };

  const handleCloseFeedback = () => {
    setOpenFeedback(false);
    setFormData(initial_values);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.feedback_type ||
      !formData.feedback ||
      !formData.user_type ||
      !formData.rating
    ) {
      enqueueSnackbar("Please fill all required fields", { variant: "error" });
      return;
    }

    const postdata = {
      first_name: formData.first_name ? String(formData.first_name) : "",
      last_name: formData.last_name ? String(formData.last_name) : "",
      email: formData.email ? String(formData.email) : "",
      feedback_type: String(formData.feedback_type),
      feedback: String(formData.feedback),
      user_type: String(formData.user_type),
      rating: parseInt(formData.rating),
    };

    setIsSubmitting(true);
    const response = await feedback_api_by_web(postdata);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      handleCloseFeedback();
      setFormData(initial_values);
      setIsSubmitting(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (openFeedback && user?.role) {
      const userType =
        user.role === "client" || user.isCompanyProfile
          ? "client"
          : "candidate";
      setFormData((prev) => ({
        ...prev,
        user_type: userType,
        feedback_type: "comment",
      }));
      setIsUserTypeDisabled(true); // Disable the radio buttons when user type is pre-selected
    } else {
      setIsUserTypeDisabled(false); // Enable radio buttons when no user type is provided
    }
  }, [openFeedback, user]);

  console.log(formData, "--formData");
  return (
    <CustomModalLayout
      open={openFeedback}
      onClose={handleCloseFeedback}
      title="We Value Your Feedback"
      subTitle="We welcome your feedback! Share your thoughts, suggestions, or concerns to help us make your experience even better."
      width="700px"
      componentToPass={
        <form onSubmit={handleSubmit}>
          {/* User Type */}

          <div className="custom-input-design">
            <label>You are*</label>

            <div className="d-flex gap-3">
              <button
                type="button"
                className={
                  formData.user_type === "client"
                    ? "chip-input-active"
                    : "chip-input"
                }
                onClick={() =>
                  setFormData({ ...formData, user_type: "client" })
                }
                disabled={isUserTypeDisabled}
              >
                <img
                  src={feedback_business_icon}
                  alt="feedback_business_icon"
                />
                <span>Client</span>
              </button>

              <button
                type="button"
                className={
                  formData.user_type === "candidate"
                    ? "chip-input-active"
                    : "chip-input"
                }
                onClick={() =>
                  setFormData({ ...formData, user_type: "candidate" })
                }
                disabled={isUserTypeDisabled}
              >
                <img src={feedback_person_icon} alt="feedback_person_icon" />
                <span>Candidate</span>
              </button>
            </div>
          </div>

          {/* Rest of your component remains the same... */}
          {/* Feedback Type */}

          <div className="custom-input-design mt-4">
            <label>Feedback Type*</label>

            <div className="d-flex gap-3">
              <button
                type="button"
                className={
                  formData.feedback_type === "comment"
                    ? "chip-input-active"
                    : "chip-input"
                }
                onClick={() =>
                  setFormData({ ...formData, feedback_type: "comment" })
                }
              >
                <img src={feedback_comment_icon} alt="feedback_business_icon" />
                <span>Comments</span>
              </button>

              <button
                type="button"
                className={
                  formData.feedback_type === "suggestion"
                    ? "chip-input-active"
                    : "chip-input"
                }
                onClick={() =>
                  setFormData({ ...formData, feedback_type: "suggestion" })
                }
              >
                <img
                  src={feedback_suggestion_icon}
                  alt="feedback_person_icon"
                />
                <span>Suggestions</span>
              </button>

              <button
                type="button"
                className={
                  formData.feedback_type === "question"
                    ? "chip-input-active"
                    : "chip-input"
                }
                onClick={() =>
                  setFormData({ ...formData, feedback_type: "question" })
                }
              >
                <img src={feedback_question_icon} alt="feedback_person_icon" />
                <span>Questions</span>
              </button>
            </div>
          </div>

          {/* Feedback Text */}

          <div className="custom-input-design mt-4">
            <label> Describe Your Feedback*</label>
            <textarea
              onChange={handleChange}
              value={formData.feedback}
              name="feedback"
              style={{ minHeight: 100 }}
              placeholder="Type your feedback here........"
            ></textarea>
          </div>

          {/* Rating */}

          <div className="custom-input-design mt-4">
            <label>How would you rate your experience?*</label>
          </div>
          <Box className="rating-box">
            <FormLabel className="form-control-label"></FormLabel>
            <Rating
              name="rating"
              value={formData.rating}
              onChange={handleRatingChange}
              size="large"
              className="rating-star"
            />
          </Box>

          {/* Anonymous Info Box */}
          <div className="info-box mt-3">
            <p className="">
              Providing your name and email is optional - your feedback can be
              submitted anonymously , and your information will be kept
              confidential.
            </p>
          </div>

          {/* Name Fields */}

          <div className="row">
            <div className="col-12 col-lg-6 mt-3">
              <div className="custom-input-design">
                <label htmlFor="">First Name</label>
                <div className="position-relative">
                  <input
                    className="ps-5"
                    name="first_name"
                    onChange={handleChange}
                    placeholder="Enter first name"
                    type="text"
                    value={formData.first_name}
                  />
                  <img
                    src={lock_icon}
                    alt="lock_icon"
                    className="input-start-icon"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 mt-3">
              <div className="custom-input-design">
                <label htmlFor="">Last Name</label>
                <div className="position-relative">
                  <input
                    className="ps-5"
                    name="last_name"
                    onChange={handleChange}
                    placeholder="Enter last name"
                    type="text"
                    value={formData.last_name}
                  />
                  <img
                    src={lock_icon}
                    alt="lock_icon"
                    className="input-start-icon"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 mt-3">
              <div className="custom-input-design">
                <label htmlFor="">Email Address</label>
                <div className="position-relative">
                  <input
                    className="ps-5"
                    name="email"
                    onChange={handleChange}
                    placeholder="example@gmail.com"
                    type="email"
                    value={formData.email}
                  />
                  <img
                    src={lock_icon}
                    alt="lock_icon"
                    className="input-start-icon"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 text-end">
            <button
              variant="contained"
              disabled={
                !formData.feedback_type ||
                !formData.feedback ||
                !formData.user_type ||
                !formData.rating
              }
              className="theme-button-contained"
              style={{ minHeight: 50, minWidth: 200 }}
              type="submit"
            >
              {IsSubmitting ? "Submitting..." : "Submit Now"}
            </button>
          </div>
        </form>
      }
    />
  );
};

export default FeedBack;
